import { Card, Table, TableBody, TableRow, TableCell, Chip, Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DataRow } from 'app/components';
import clsx from 'clsx';
import React from 'react';
import TitleField from '../TitleField';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(2),
    width: '100%',
  },
  chip: {
    margin: theme.spacing(0.5),
    maxWidth: 400,
    height: 'auto',
    '& .MuiChip-label': {
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    },
  },
  section: {
    marginTop: theme.spacing(1),
  },
  sectionTitle: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
  },
  chipRow: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  labelCell: {
    fontWeight: 'bold',
    verticalAlign: 'top',
  },
  valueCell: {
    padding: '8px',
  },
  legend: {
    display: 'flex',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    fontSize: 12,
  },
  legendDot: {
    width: 12,
    height: 12,
    borderRadius: '50%',
  },
}));

const RegtankRiskTable = ({ kyc = {}, risk = {}, className }) => {
  const classes = useStyles();

  const riskTags = Array.isArray(risk?.riskTags) ? risk.riskTags : [];

  // Group by type
  const typeGroups = {
    DETECT: riskTags.filter(t => t.type === 'DETECT'),
    COMPARE: riskTags.filter(t => t.type === 'COMPARE'),
    AUTHENTICATE: riskTags.filter(t => t.type === 'AUTHENTICATE'),
    ANALYSE: riskTags.filter(t => t.type === 'ANALYSE'),
  };

  const getChipStyle = (icon) => {
    if (icon === 'GREEN') return { backgroundColor: '#70d602', color: '#000' };
    if (icon === 'YELLOW') return { backgroundColor: '#ffc15d', color: '#000' };
    if (icon === 'RED') return { backgroundColor: '#fdecea', color: 'red' };
    return { backgroundColor: '#e0e0e0', color: '#000' };
  };

  const typeLabels = {
    DETECT: 'Detection',
    COMPARE: 'Comparison',
    AUTHENTICATE: 'Authentication',
    ANALYSE: 'Analyse',
  };

  return (
    <Card className={clsx(classes.card, className)}>
      <TitleField>KYC & Risk Summary</TitleField>

      <Table>
        <TableBody>
          {/* KYC */}
          <DataRow name="KYC Match" value={kyc?.kycPositiveMatch ? 'Yes' : 'No'} />
          <DataRow name="KYC Type" value={kyc?.kycType || '-'} />
          <DataRow name="Risk Count" value={riskTags.length} />

          {/* Risk Flags grouped by type */}
          <TableRow>
            <TableCell className={classes.labelCell}>Risk Flags</TableCell>
            <TableCell className={classes.valueCell}>
              {/* Legend */}
              <Box className={classes.legend}>
                <Box className={classes.legendItem}>
                  <Box className={classes.legendDot} style={{ backgroundColor: '#70d602' }} />
                  <Typography variant="caption">Passed</Typography>
                </Box>
                <Box className={classes.legendItem}>
                  <Box className={classes.legendDot} style={{ backgroundColor: '#ffc15d' }} />
                  <Typography variant="caption">Warning</Typography>
                </Box>
                <Box className={classes.legendItem}>
                  <Box className={classes.legendDot} style={{ backgroundColor: '#fdecea', border: '1px solid red' }} />
                  <Typography variant="caption">Critical</Typography>
                </Box>
              </Box>

              {Object.entries(typeGroups).map(([type, tags]) => (
                tags.length > 0 && (
                  <Box key={type} className={classes.section}>
                    <Typography className={classes.sectionTitle}>
                      {typeLabels[type]}
                    </Typography>
                    <Box className={classes.chipRow}>
                      {tags.map((tag, index) => (
                        <Chip
                          key={index}
                          label={tag.text}
                          size="small"
                          className={classes.chip}
                          style={getChipStyle(tag.icon)}
                        />
                      ))}
                    </Box>
                  </Box>
                )
              ))}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Card>
  );
};

export default RegtankRiskTable;